import { useStore } from "../designer/Store/zustandStore";
export default function Drawings() {
  const [drawings] = useStore((state) => [state.drawings]);

  return (
    <div className="p-5">
      {drawings?.length > 0 && (
        <>
          <h4>Side view</h4>
          <hr />
<div style={{ width: "100%" }}>
  <img
    src={drawings[0].side}
    alt="side view"
    style={{
      width: "100%",
      height: "auto",
      maxHeight: "1000px",   // limits height
      objectFit: "contain"  // optional
    }}
  />
</div>

          <h4 className="mt-4">Top view</h4>
          <hr />

          <div style={{ width: "100%" }}>
            <img
              src={drawings[0].top}
              alt="top view"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
                objectPosition: "top",
                maxHeight:"1000px"
              }}
            />
          </div>
          {/* <h4 className="mt-4">Combined view</h4>
          <hr /> */}

          {/* <div style={{ width: "100%" }}>
            <img
              src={drawings[0].combined}
              alt="top view"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
                objectPosition: "top",
                maxHeight:"1000px"
              }}
            />
          </div> */}
        </>
      )}
    </div>
  );
}